module.exports = __webpack_public_path__ + "img/alert-green.c02f2be8.svg";